<button *ngIf="insideClassificationImage !== true && imageClassificationList && currentClassification"
  #popover="ngbPopover" placement="bottom" [ngbPopover]="popContentImageClassification" data-container="body"
  class="btn btn-secondary" [ngClass]="{'btn-secondary': currentClassification.tchekPtr === undefined,
         'btn-primary' :  currentClassification.tchekPtr !== undefined}">Image
  Classification</button>

<ng-template #popContentImageClassification>
  <div class="col-12 mt-2 p-0 tweaker-body">
    <div class="row m-0 p-0" style="min-width: 260px;">

      <div class="col-12">
        <div class="row" id='row1'>
          <div class="col-* ml-auto mr-auto" *ngFor="let attributesList of imageClassificationList">
            <label for="{{attributesList.label}}" class="m-0  p-0">
              <input id="{{attributesList.label}}" [value]='attributesList.label' type="radio"
                name="{{attributesList.label}}" [(ngModel)]="currentClassification.attributes.status"
                (click)='changeStatus()'>
              <span class="ImageClassification">{{attributesList.label}}</span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 m-0 p-0">
        <div *ngIf="getImageClassificationList(currentClassification.attributes.status)">
          <div class="col-12 mb-1"
            *ngFor="let values of getImageClassificationList(currentClassification.attributes.status)">
            <span class="ImageClassification">{{ values.label }} :</span>
            <div class="row ml-1 mr-1">
              <div *ngFor="let v of values.options" class="col*">
                <label class="checkbox-container">
                  <input type="checkbox" [checked]="getImageClassificationOptionChecked(values.label, v)"
                    (click)="toggleCheckbox($event, values.label, v)">
                  <span class="checkmark"></span></label>
                {{v}}
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="col-12" *ngIf="getImageClassificationList(currentClassification.attributes.status)">
        <label class="checkbox-container">
          <input type="checkbox" [checked]="currentClassification.forValidation"
            (click)="currentClassification.forValidation = !currentClassification.forValidation; save()">
          <span class="checkmark"></span></label>
        For Validation
      </div>


    </div>
  </div>
</ng-template>

<div class="d-block container mt-2" style="height: 100vh;" *ngIf="insideClassificationImage">
  <div class="row" id='row1'>
    <div class="col-* ml-auto mr-auto" *ngFor="let attributesList of imageClassificationList">
      <label for="{{attributesList.label}}" class="m-0  p-0">
        <input id="{{attributesList.label}}" [value]='attributesList.label' type="radio" name="{{attributesList.label}}"
          [(ngModel)]="currentClassification.attributes.status" (click)='changeStatus()'>
        <span class="ImageClassification">{{attributesList.label}}</span>
      </label>
    </div>
  </div>
  <div class="row mb-2" id='row2'>
    <div class="col-12 m-0 p-0">
      <div *ngIf="getImageClassificationList(currentClassification.attributes.status)">
        <div class="col-12 mb-1"
          *ngFor="let values of getImageClassificationList(currentClassification.attributes.status)">
          <span class="ImageClassification">{{ values.label }} :</span>
          <div class="row ml-1 mr-1">
            <div *ngFor="let v of values.options" class="col*">
              <label class="checkbox-container">
                <input type="checkbox" [checked]="getImageClassificationOptionChecked(values.label, v)"
                  (click)="toggleCheckbox($event, values.label, v)">
                <span class="checkmark"></span></label>
              {{v}}
            </div>
          </div>
        </div>
        <div class="col-12 mt-2 mb-2">
          <button *ngIf="showbutton" type="button" class="btn btn-lg primary w-100" i18n="modal_damage|@@nextImage"
            (click)="saveImageClassification()">Image Suivante</button>
          <button *ngIf="showbutton === false" type="button" class="btn btn-lg btn-secondary w-100"
            i18n="modal_damage|@@loading">Chargement ...</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row ml-1 mr-1" style="overflow-y: scroll;" id='row3'>
    <div class="row m-0 p-0" *ngIf="resultClassification">
      <span class="ImageClassification">Inspection Auto :</span>
      <div class="col-12 mb-4 p-0" *ngFor="let key of getData(resultClassification)">
        <span class='classificationHead'>{{key[0]}}</span>
        <div class="col-12" *ngFor="let array of  key[1]">
          {{array[0]}} : {{array[1].toFixed(2)}} %
          <div class="progress">
            <div class="progress-bar" role="progressbar" [ngStyle]="{'width.%': array[1]}" aria-valuenow="100"
              aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/image-classification/image-classification.component.html